module.exports = __webpack_public_path__ + "static/media/lumbering18.df2c2c85.jpg";